// useHosterModeManager.ts
// Custom hook to manage hosterMode state with localDB persistence

import { useCallback } from 'react';
import { localDB } from '../../../../../crud/localDB/localDB';

interface UseHosterModeManagerProps {
  hosterMode: boolean;
  setHosterMode: (mode: boolean) => void;
}

interface UseHosterModeManagerReturn {
  handleSetHosterMode: (newHosterMode: boolean) => Promise<void>;
}

export const useHosterModeManager = ({
  hosterMode,
  setHosterMode,
}: UseHosterModeManagerProps): UseHosterModeManagerReturn => {
  
  const handleSetHosterMode = useCallback(async (newHosterMode: boolean) => {
    setHosterMode(newHosterMode);
    
    try {
      await localDB.set('restaurant', 'hosterMode', newHosterMode);
    } catch (error) {
      console.error('Failed to persist hosterMode:', error);
    }
  }, [setHosterMode]);

  return {
    handleSetHosterMode,
  };
};
